angular.module('acme.view.application.orders.offline', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.orders.offline.list'
]).config(function config($stateProvider) {
  var offline = {
    name: 'application.orders.offline',
    url: '/offline-transactions',
    abstract: true,
    views: {
      "subview-main": {
        templateUrl: 'views/application/views/orders/offline/offline.tpl.html'
      }
    }
  };

  $stateProvider
    .state(offline);
});
